<div class="modal-content">
  <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
    <p *ngIf="type === 'create'" class="modal-title h4" jhiTranslate="modals.addOrUpdateInsuranceItem.titleCreate"></p>
    <p *ngIf="type === 'update'" class="modal-title h4" jhiTranslate="modals.addOrUpdateInsuranceItem.titleUpdate"></p>
  </div>

  <form>
    <div class="modal-body text-left">
      <div class="row" *ngIf="controls">
        <div class="col-12"><span class="font-weight-bold" jhiTranslate="modals.addOrUpdateInsuranceItem.subTitle"></span></div>
        <div class="col-12">
          <jhi-bary-input-text [control]="controls.itemsNature" [label]="'modals.addOrUpdateInsuranceItem.itemsNature' | translate"></jhi-bary-input-text>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number
            [control]="controls.maxValue"
            [max]="500000"
            [step]="1000"
            [label]="'modals.addOrUpdateInsuranceItem.maxValue' | translate"
          ></jhi-bary-input-number>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number [control]="controls.basePricing" [label]="'modals.addOrUpdateInsuranceItem.basePricing' | translate"></jhi-bary-input-number>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number
            [control]="controls.insuranceRate"
            [max]="1"
            [min]="0"
            [step]="0.1"
            [label]="'modals.addOrUpdateInsuranceItem.insuranceRate' | translate"
          ></jhi-bary-input-number>
        </div>
        <div class="col-12 col-md-6">
          <jhi-bary-input-number
            [control]="controls.pricingRate"
            [max]="1"
            [min]="0"
            [step]="0.1"
            [label]="'modals.addOrUpdateInsuranceItem.pricingRate' | translate"
          ></jhi-bary-input-number>
        </div>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer justify-content-end">
      <jhi-bary-button
        [outline]="true"
        color="primary"
        [label]="'modals.addOrUpdateInsuranceItem.buttons.first' | translate"
        (clickEvent)="handleClick({ first: true })"
      ></jhi-bary-button>
      <jhi-bary-button (clickEvent)="handleSubmit()" [label]="'modals.addOrUpdateInsuranceItem.buttons.' + type | translate" color="primary"></jhi-bary-button>
    </div>
  </form>
</div>
